import request from 'superagent';
import { getUserToken } from 'services/authentication';

function selectQuery(options) {
  return options && options.query ? options.query : {};
}

function selectHeaders({ headers = {} }) {
  return {
    ...headers,
    Accept: 'application/json',
    Authorization: `Bearer ${getUserToken()}`,
  };
}

function factory(host) {
  return {
    get: (path, options = {}) =>
      request
        .get(`${host}${path}`)
        .query(selectQuery(options))
        .set(selectHeaders(options)),
    post: (path, data, options = {}) =>
      request
        .post(`${host}${path}`)
        .query(selectQuery(options))
        .set(selectHeaders(options))
        .send(data),
    patch: (path, data, options = {}) =>
      request
        .patch(`${host}${path}`)
        .query(selectQuery(options))
        .set(selectHeaders(options))
        .send(data),
    put: (path, data, options = {}) =>
      request
        .put(`${host}${path}`)
        .query(selectQuery(options))
        .set(selectHeaders(options))
        .send(data),
    delete: (path, options = {}) =>
      request
        .del(`${host}${path}`)
        .query(selectQuery(options))
        .set(selectHeaders(options)),
  };
}

export default factory;
